import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgStarCircle = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3.5 12a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M13.062 6.933a1.164 1.164 0 0 0-2.103 0L9.817 9.24 7.31 9.61a1.165 1.165 0 0 0-.682 2l1.84 1.775-.439 2.564v.001a1.173 1.173 0 0 0 1.704 1.236l.002-.001 2.274-1.202 2.275 1.202h.002a1.172 1.172 0 0 0 1.704-1.235l-.439-2.537 1.82-1.805a1.164 1.164 0 0 0-.648-1.996l-2.52-.373zm.761 3.766a1.14 1.14 0 0 1-.892-.651l-.92-1.858-.92 1.858a1.14 1.14 0 0 1-.893.651l-2.04.302 1.474 1.423a1.16 1.16 0 0 1 .345 1.04l-.357 2.085 1.84-.972.02-.01a1.2 1.2 0 0 1 1.08.01l1.84.972-.355-2.052v-.002a1.16 1.16 0 0 1 .339-1.036L15.854 11z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgStarCircle;
